
import React from 'react';

const TabPanel = (props) => {
    return (
        props.children
    );
}

export default TabPanel;
